import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import CustomizedBreadcrumbs from "../../components/Custom/CustomizedBreadcrumbs";
import CustomizedMenuBox from "../../components/Custom/CustomizedMenuBox";
import { useAuth, usePermission } from "../../hooks/use-auth";

const Logistic = () => {
  const { permissions } = useAuth();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const [allPermissionList, setAllPermissionList] = useState([]);

  const isAdmin = "ADMIN__ADMIN__ADMIN";

  useEffect(() => {
    setAllPermissionList(permissions);
  }, [permissions]);

  const breadcrumbs = [
    {
      name: t("logistic.index"),
    },
  ];

  const {
    deliveryOrderPermission,
    deliveryTripPermission,
    deliveryReportPermission,
  } = usePermission();

  const menuList = [
    allPermissionList.some((permission) =>
      [deliveryOrderPermission.VIEW, isAdmin].includes(permission)
    ) && {
      title: t("logistic.deliveryOrder.index"),
      navigateTo: "delivery-order",
    },
    allPermissionList.some((permission) =>
      [deliveryTripPermission.VIEW, isAdmin].includes(permission)
    ) && {
      title: t("logistic.deliveryTrip.index"),
      navigateTo: "delivery-trip",
    },
    allPermissionList.some((permission) =>
      [deliveryReportPermission.VIEW, isAdmin].includes(permission)
    ) && { title: t("logistic.report.index"), navigateTo: "report" },
  ];

  const formatMenuList = menuList.filter((menu) => menu !== false);

  const renderMenuList = () =>
    formatMenuList.map((menu) => (
      <Grid item xs={12} sm={6} md={3} lg={3} xl={2} key={menu.title}>
        <CustomizedMenuBox
          title={menu.title}
          linkTo={`${pathname}/${menu.navigateTo}`}
          isGridItem
        />
      </Grid>
    ));

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ my: 2 }}>
        <Grid container spacing={1}>
          {renderMenuList()}
        </Grid>
      </Box>
    </>
  );
};

export default Logistic;
